import {
  ESTUDIOGRUPO_SUCCESS,
  ESTUDIOGRUPO_LOADING,
  ESTUDIOGRUPO_ERROR,
  ESTUDIOMASBUSCADO_SUCCESS,
  ESTUDIOMASBUSCADO_LOADING,
  ESTUDIOMASBUSCADO_ERROR,
  ESTUDIOMASBUSCADO_RESET,
  ESTUDIOGRUPO_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

export const estudioGrupo = () => (dispatch) => {
  dispatch({
    type: ESTUDIOGRUPO_LOADING,
  });
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/estudios/grupos`)
      .then((res) => {
        dispatch({
          type: ESTUDIOGRUPO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: ESTUDIOGRUPO_ERROR,
          payload: error,
        });
      });
  });
};

export const estudiosMasSolicitadosPorPaciente =
  (idPacFamiliar) => (dispatch) => {
    dispatch({
      type: ESTUDIOMASBUSCADO_LOADING,
    });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/estudios/grupos/paraPaciente/${idPacFamiliar ? idPacFamiliar : -1}`
        )
        .then((res) => {
          dispatch({
            type: ESTUDIOMASBUSCADO_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: ESTUDIOMASBUSCADO_ERROR,
            payload: error,
          });
        });
    });
  };

export const resetEstudioMasBuscado = () => (dispatch) => {
  dispatch({
    type: ESTUDIOMASBUSCADO_RESET,
  });
};

export const resetEstudioGrupo = () => (dispatch) => {
  dispatch({
    type: ESTUDIOGRUPO_RESET,
  });
};
